// The Case Sheet's section navigation — the shared PriorityTabNav over
// caseSheetTabs.ts's list. See components/ui/PriorityTabNav.tsx for how the
// strip and the More menu behave.
import { PriorityTabNav } from '@/components/ui/PriorityTabNav';
import type { CaseSheetTab, TabId } from './caseSheetTabs';

export function CaseSheetTabNav({ tabs, active, onSelect }: {
  tabs: readonly CaseSheetTab[];
  active: TabId;
  onSelect: (id: TabId) => void;
}) {
  return <PriorityTabNav tabs={tabs} active={active} onSelect={onSelect} ariaLabel="Case sheet sections" />;
}
